import * as React from 'react';
import { connect } from 'react-redux';
import { CollisionList } from 'components/History/CollisionList';
import { withTranslation  } from 'react-i18next';
import { CarCollisionDto } from 'Models/CollisionModel';
import { RootState } from 'Redux/Reducers/_RootReducer';
import * as CollisionActions from "Redux/Actions/CollisionActions"
import { createSerachQuery } from 'Connectors/_main';
import {checkPageQuery} from 'HelperFunctions/Lists';

type ConnectedProps = {
    collisionList?:Array<CarCollisionDto>
}

type ConnectedDispatch = {
    pullCollisionList?:(filter?:URLSearchParams)=>void,
    setActiveCollision?:(collisionId:number)=>void
}

export class CollisionListPage extends React.Component<ConnectedProps & ConnectedDispatch,any> {
    constructor(props) {
        super(props);
    }

    public componentDidMount() {
        this.props.pullCollisionList();
    }

    private setActiveCollision = (collision:CarCollisionDto) => {
        this.props.setActiveCollision(collision.id);
    }

    private onFilterChange = (state) => {
        const query = checkPageQuery(state.filtered, state.page);
        const params = createSerachQuery(query);
        this.props.pullCollisionList(params);
    }

    public render() {
        return (
            <div className="main__content main__content--no-padding">
                <CollisionList data={this.props.collisionList} setActive={this.setActiveCollision} onFilterChange={this.onFilterChange} />
            </div>
        )
    }

    public componentWillUnmount() {
        this.props.setActiveCollision(null);
    }
}

function mapStateToProps(state: RootState): ConnectedProps {
    return {
        collisionList:state.historyCollision.collisionList.toArray()
    };
}
function mapDispatchToProps(dispatch: any): ConnectedDispatch {
    return {
        pullCollisionList:(filter?:URLSearchParams) => dispatch(CollisionActions.pullCollisionsList(filter)),
        setActiveCollision:(collisionId:number) => dispatch(CollisionActions.setActiveCollision(collisionId))
    };
}

export default withTranslation ('carDetails')(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(CollisionListPage) as React.ComponentType<any>
)



// WEBPACK FOOTER //
// ./src/components/History/CollisionListPage.tsx